import constants from "../common/constants";

const devEndpointExt = "https://localhost:5000";

const endpoint1 =
  constants.env_ === "Dev"
    ? devEndpointExt
    : constants.domain + "rafa/portal/api";

// ------------------------------------------------------ Endpoints
const api = {
  gRepcatchaVerification: `${endpoint1}/common/getgrecaptchaverification`,
  postRepcatchaVerification: `${endpoint1}/common/postrecaptchaverification`,
  femsValidateToken: `${endpoint1}/systemaccess/validate_token`,
  femsLogin: `${endpoint1}/systemaccess/login`,
  femsLogout: `${endpoint1}/systemaccess/logout`,
  femsRefreshToken: `${endpoint1}/systemaccess/refresh_token`,
  femsRecoverPassword: `${endpoint1}/systemaccess/recoverpassword`,
  femsResetPassword: `${endpoint1}/systemaccess/resetpassword`,
  femsChangePassword: `${endpoint1}/systemaccess/changepassword`,
  femsAmmGetTicketList: `${endpoint1}/FeasData/getticketlist`,
  GetIncidents: `${endpoint1}/FeasData/getiraincidents`,
  // =======================================================================================================================
};

export default Object.freeze(api);
